const { Fragment, useEffect, useState, useRef } = wp.element;
const { __ } = wp.i18n;
import Settings from "./settings";
import { simplePlaylist } from "../../js/playlist";
import Style from "./Style";
const { Button } = wp.components;
const Edit = (props) => {
  const { attributes, isSelected, setAttributes, clientId } = props;
  const { uniqueId, audios, hideDownload, theme, align } = attributes;
  const [player, setPlayer] = useState(null);
  const dom = useRef();

  setAttributes({ clientId });
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (player) {
      player.destroy();
    }
    const pl = simplePlaylist(dom.current, {}, audios);
    setPlayer(pl);
  }, []);

  useEffect(() => {
    setAttributes({ uniqueId: "h5ap" + clientId.substr(0, 8) });
  }, []);

  const handleAddItem = () => {
    const newAudios = [...audios];
    newAudios.push({
      title: "audio tile",
      source: "",
      artist: "",
    });
    setAttributes({ audios: newAudios });
  };

  return (
    <Fragment>
      <Style {...props} />
      <Settings props={props} currentIndex={currentIndex} />
      <div id={uniqueId} className={`h5ap_player align${align}`}>
        <div ref={dom} className={`narrowPlaylist simplePlaylist audioPlaylist theme-${theme.toLowerCase()}`}>
          <audio></audio>
          <ul>
            {audios.map(({ title, source, artist }, index) => {
              return (
                <li key={index} data-audio-item data-index={index} onClick={() => setCurrentIndex(index)}>
                  <span className="title">{title}</span>
                  {artist && (
                    <span className="artist">
                      {__(" by ", "h5ap")} {artist}{" "}
                    </span>
                  )}
                  {!hideDownload && (
                    <a className="download" download href={source}>
                      <svg role="presentation" focusable="false">
                        <use href="#plyr-download"></use>
                      </svg>
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
          {isSelected && (
            <div id="h5apGutenMenu">
              <Button variant="primary" onClick={handleAddItem}>
                {__("Add New Item", "h5ap")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Edit;
